module.exports = __webpack_public_path__ + "static/fonts/Arimo-Regular.d9cc167.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/arimo/Arimo-Regular.ttf
// module id = 568
// module chunks = 9